var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15 4c-2.753 0-5 2.247-5 5v46c0 2.753 2.247 5 5 5h34c2.753 0 5-2.247 5-5V20c0-.91-.37-1.77-.992-2.406L40.715 5.008A3.38 3.38 0 0 0 38.293 4zm0 2h23v10c0 2.199 1.801 4 4 4h10v35c0 1.68-1.32 3-3 3H15c-1.68 0-3-1.32-3-3V9c0-1.68 1.32-3 3-3zm25 1.139L50.61 18H42c-1.125 0-2-.875-2-2z",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 26c-1.09 0-2 .91-2 2v22c0 1.09.91 2 2 2h24c1.09 0 2-.91 2-2V28c0-1.09-.91-2-2-2zm0 2h6v6h-6zm8 0h16v6H28zm-8 8h6v6h-6zm8 0h16v6H28zm-8 8h6v6h-6zm8 0h16v6H28z",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.4d33fd195195def86a1c0bbed4ec6a30.svg";
export { ForwardRef as ReactComponent };